import { Box } from '@deckee/deck-hand';
import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { captureEvent } from '../../../../services/event-capture';
import {
  clearSelectedCategory,
  selectAllMarketplaceCategories,
  setSelectedCategory,
} from '../../../../services/store/modules/marketplace';
import BasicDrawerLayout from '../../../layouts/BasicDrawerLayout/BasicDrawerLayout';
import ServicesCategoryCard from '../components/ServicesCategoryCard/ServicesCategoryCard';

const ServicesCategoriesPage: FC = () => {
  const categories = useSelector(selectAllMarketplaceCategories);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearSelectedCategory());
  }, [dispatch]);

  const handleSelectCategory = (id: string, name: string) => {
    captureEvent({
      type: 'marketplace: select category',
      payload: {
        name,
      },
      sendToAmplitude: true,
    });
    dispatch(setSelectedCategory(id));
  };

  return (
    <BasicDrawerLayout showHeaderBar={false}>
      <Box
        display="flex"
        flexWrap="wrap"
        boxSizing="border-box"
        p="3"
        justifyContent="space-between"
      >
        {categories.map((category) => (
          <Box key={category.name} flex="0 0 48%" minHeight="175px" my="2">
            <ServicesCategoryCard
              name={category.name}
              url="/maps/marketplace/search"
              imageUrl={category.image}
              onSelectCategory={() =>
                handleSelectCategory(category.id, category.name)
              }
            />
          </Box>
        ))}
      </Box>
    </BasicDrawerLayout>
  );
};

export default ServicesCategoriesPage;
